import React, { useState, useEffect } from "react";
import { Label, Input, Row, Col, Button, Table, FormGroup } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "./index.css";
import Select from "react-select";
import ApiCaller from "../../../../api/apiCaller";
import CustomTextInput from "../../../../components/CustomTextInput";
import CustomDropdownInput from "../../../../components/CustomDropdownInput";
import CityPicker from "../../../../components/CityPicker";
import StorePlanningMap from "../../../StorePlanning/pages/Map";
import moment from "moment";
import "moment/locale/vi";
import t from "utils/Lang";

const SiteActivityAttributes = [
  { name: "from_date", type: "date", label: t().site_activity_modal__from },
  { name: "to_date", type: "date", label: t().site_activity_modal__to },
  { name: "note", type: "textarea", label: t().site_activity__note },
];

interface SiteActivityModalProps {
  siteId?: any;
  isShow?: boolean;
  siteActivity?: any;
  onModalToogle?: Function;
  onSaved?: Function;
}

export default function SiteActivityModal({
  siteId,
  isShow,
  siteActivity,
  onModalToogle,
  onSaved,
}: SiteActivityModalProps) {
  const [siteActivities, setSiteActivities] = useState<Array<any>>([]);
  const [siteActivityTypes, setSiteActivityTypes] = useState<Array<any>>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [isLoadLog, setIsLoadLog] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(isShow || false);
  const [selectedSiteActivityType, setSelectedSiteActivityType] = useState<any>(
    {}
  );
  const [siteActivityData, setSiteActivityData] = useState<any>(
    siteActivity || {
      name: "",
      site_id: siteId,
    }
  );

  const getSiteActivityTypes = async () => {
    setIsLoadLog(true);
    const uri = `site_activity_type/`;
    const res = await ApiCaller.get(uri);
    if (res?.result) {
      setSiteActivityTypes([...siteActivityTypes, ...res?.result]);
    }
  };

  const saveSiteActivity = async () => {
    let uri = `site_activity/`;
    let res = null;
    if (siteActivityData?.id) {
      uri = `site_activity/${siteActivityData?.id}`;
      res = await ApiCaller.put(uri, siteActivityData);
    } else {
      res = await ApiCaller.post(uri, siteActivityData);
    }
    if (res?.status === "ok") {
      alert("Đã lưu thành công");
      if (onSaved) {
        onSaved(siteActivityData);
      }
      toogleModal();
    }
  };

  const deleteSiteActivity = async () => {
    const r = window.confirm("Bạn có chắc muốn xóa hoạt động này?");
    if (!r) return;
    const uri = `site_activity/${siteActivityData?.id}`;
    const res = await ApiCaller.delete(uri);
    if (res?.status === "ok") {
      toogleModal();
      if (onSaved) {
        onSaved(siteActivityData);
      }
    }
  };

  const toogleModal = () => {
    const newShowModalState = !showModal;
    setShowModal(newShowModalState);
    if (onModalToogle) {
      onModalToogle(newShowModalState);
    }
  };

  const onSiteActivityTypesSelected = (selectedOption: any) => {
    setSiteActivityData({
      ...siteActivityData,
      site_activity_type_id: selectedOption.value,
      site_activity_type: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const updateAttr = (attrName: string, value: any) => {
    const updatedData = {
      ...siteActivityData,
    };
    updatedData[attrName] = value;
    setSiteActivityData(updatedData);
  };

  useEffect(() => {
    getSiteActivityTypes();
  }, []);

  const siteActivityTypeNormalized = {
    value: siteActivityData?.site_activity_type?.id,
    label: siteActivityData?.site_activity_type?.name,
  };
  return (
    <Modal isOpen={showModal} toggle={toogleModal}>
      <ModalHeader toggle={toogleModal}>
        {t().site_activity_modal__title}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col xs={12}>
            <FormGroup>
              <Label>{t().site_activity_modal__type_activity}</Label>
              <Select
                options={siteActivityTypes.map((siteActivityType: any) => {
                  return {
                    label: siteActivityType.name,
                    value: siteActivityType.id,
                  };
                })}
                value={siteActivityTypeNormalized}
                onChange={(selectedOption: any) =>
                  onSiteActivityTypesSelected(selectedOption)
                }
              />
            </FormGroup>
          </Col>
          {SiteActivityAttributes.map((siteActivityAttribute: any) => (
            <Col xs={12} id={siteActivityAttribute.name} key={siteActivityAttribute.name}>
              <FormGroup>
                <Label>{siteActivityAttribute.label}</Label>
                <Input
                  type={siteActivityAttribute.type}
                  name={siteActivityAttribute.name}
                  onChange={(e) =>
                    updateAttr(siteActivityAttribute.name, e.target.value)
                  }
                  value={siteActivityData[siteActivityAttribute.name]}
                />
              </FormGroup>
            </Col>
          ))}
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={deleteSiteActivity}>
          {t().action__delete}
        </Button>{" "}
        <Button color="secondary" onClick={toogleModal}>
          {t().action__cancel}
        </Button>{" "}
        <Button color="primary" onClick={saveSiteActivity}>
          {t().action__save}
        </Button>{" "}
      </ModalFooter>
    </Modal>
  );
}

const styles = {
  controls: {
    paddingTop: 12,
    paddingBottom: 12,
  },
  loadMoreButton: {
    width: "100%",
    marginTop: 12,
    marginBottom: 12,
  },
  tableTitle: {
    borderWidth: 0,
    borderBottomWidth: 2,
    borderColor: "#263F76",
    color: "#263F76",
    minWidth: 200,
  },
};
